import { useEffect } from "react";

// Per-page browser titles: "Royal look — Rangrez". The brand comes from admin
// settings (cached in localStorage by App.js), so nothing is hardcoded.

const brandName = () => {
  try {
    return (localStorage.getItem("brandName") || "").trim();
  } catch (e) {
    return "";
  }
};

let currentPage = "";

export const formatTitle = (page) => {
  const brand = brandName();
  if (!page) return brand || document.title;
  return brand ? `${page} — ${brand}` : page;
};

// The page title App.js should keep when settings load after the page did.
export const currentPageTitle = () => currentPage;

export function usePageTitle(page) {
  useEffect(() => {
    if (!page) return undefined;
    currentPage = page;
    document.title = formatTitle(page);
    return () => {
      currentPage = "";
      document.title = brandName() || document.title;
    };
  }, [page]);
}
